import { computed, observable } from 'mobx';
import { BaseStore } from './BaseStore';
import { Stores } from '../models/Stores';
import { models, query, utils } from '@kurtosys/ksys-app-template/dist';
const Query = query.Query;

export class QueryStore extends BaseStore {
    @observable.ref
    defaultContext: models.query.IQueryContext;

    constructor(stores: Stores) {
        super(stores);
    }

    get inputs() {
        return this.stores.data.appDataProps;
    }

    get culture() {
        return this.stores.data.culture;
    }

    @computed
    get translationHelper() {
        // const { translation } = this.stores;
        // TODO: Create TranslationHelper instance based on Fund Center TranslationStore and return. (has not been used previously)
        return null;
    }

    getExecutionOptionsUsingContext(
        context: models.query.IQueryContext
    ): models.query.IExecutionOptions {
        return {
            context: utils.object.deepMergeObjectsWithOptions(
                {},
                this.defaultContext,
                context
            ),
            fallbackCulture: 'en-GB',
            culture: this.culture,
            inputs: this.inputs,
            // TODO: add below items to completely integrate with Query options (has not been used previously)
            // applicationGuid: appStore.applicationGuid,
            // defaultContextParentKey: this.defaultContextParentKey,
            // responseContext: this.responseContext,
            // fundManagerContext: this.fundManagerContext,
            // statisticContext: this.statisticContext,
            // translate: translationStore.translate,
            // serviceUrl: appStore.serviceUrl,
            // globalFormatsByKey: appStore.globalFormatsByKey,
        };
    }

    loadDefaultContext = () => {
        const defaultContext: models.query.IQueryContext = {
            globalDisclaimers: this.stores.disclaimer.rawDisclaimers.map(d => {
                return {
                    disclaimerType: d.disclaimerType,
                    disclaimers: d.disclaimers,
                } as models.api.dictionary.IDisclaimer;
            }),
            globalCommentaries: this.stores.commentary.rawCommentaries.map(
                c => {
                    return {
                        commentaryType: c.commentaryType,
                        commentaries: c.commentaries,
                    } as any;
                }
            ),
        };
        this.defaultContext = defaultContext;
    };

    execute(
        options: models.query.IQueryOptions,
        executionOptions: models.query.IExecutionOptions
    ) {
        if (options) {
            const queryInstance = new Query(options, this.translationHelper);
            return queryInstance.execute(executionOptions);
        }
    }

    mergeQueriesAndProps<T>(
        componentOrchestration: { props: any; queries: any },
        executionOptions: models.query.IExecutionOptions
    ): T | undefined {
        if (componentOrchestration) {
            const { props, queries } = componentOrchestration;
            const queryResults = queries
                ? query.Query.convertQueryMime(queries, executionOptions, {
                      translationHelper: this.translationHelper,
                  })
                : {};
            const response: T = utils.object.deepMergeObjectsWithOptions(
                { arrayMergeStrategy: 'DeepMerge' },
                props || {},
                queryResults
            );
            return response;
        }
    }
}



// WEBPACK FOOTER //
// ./src/stores/QueryStore.ts